import { useContext, useEffect, useState } from 'react'
import { PingIdentityContext } from '@rsmus/react-pingidentity'
import ky from '@rsmus/ky-auth'
import { buildApiUrl } from '../apiUrl'

export const useHasInternalClaim = () => {
  const { loadingClaims, user } = useContext(PingIdentityContext)
  const [authorized, setAuthorized] = useState<boolean>()
  const [checkingAuthorization, setCheckingAuthorization] = useState(false)

  useEffect(() => {
    let cancelled = false

    if (loadingClaims) {
      return
    }

    if (!user) {
      setAuthorized(false)
      return
    }

    const checkAuthorization = async () => {
      setCheckingAuthorization(true)
      try {
        const response = await ky.get(
          buildApiUrl('UserProfiles/CanAccessEngagementManager'),
          {
            throwHttpErrors: false,
            timeout: 300000,
          }
        )

        if (!cancelled) {
          setAuthorized(response.ok)
        }
      } catch {
        if (!cancelled) {
          setAuthorized(false)
        }
      } finally {
        if (!cancelled) {
          setCheckingAuthorization(false)
        }
      }
    }

    checkAuthorization()

    return () => {
      cancelled = true
    }
  }, [loadingClaims, user])

  return {
    authorized,
    isLoading: loadingClaims || checkingAuthorization || authorized === undefined,
  }
}
